import { StripeElementStyle } from '@stripe/stripe-js';
import { legacyThemeColors } from '../theme/legacyThemeColors';
import { Theme } from '../theme/useTheme';

const { textColor } = legacyThemeColors;

export default function getStripeElementsStyle(theme: Theme): StripeElementStyle {
  const text = textColor[`${theme}-base`];
  const placeholder = textColor[`${theme}-muted`];
  const invalid = textColor[`${theme}-alert-critical`];
  return {
    base: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '21px',
      fontFamily: 'Public Sans, sans-serif',
      fontSmoothing: 'antialiased',
      color: text,
      '::placeholder': {
        color: placeholder,
      },
    },
    invalid: {
      color: invalid,
    },
  };
}
